export const APPEAL_CURRENT_STATUS_LABELS: Record<string, string> = {
  REFERRED: "Referred",
  REFERRAL_IN_PROGRESS: "Referral in progress",
  IN_PROGRESS: "In Progress",
  LETTER_GENERATING: "Letter Generating",
  LETTER_GENERATED: "Letter Generated",
  IN_SUPPORT: "In Support",
  SUBMITTED: "Submitted",
  UPHELD: "Upheld",
  OVERTURNED: "Overturned",
  EXPIRED: "Expired",
  CLOSED: "Closed",
};

export const getAppealCurrentStatusLabel = (
  currentStatus: string | null | undefined,
): string => {
  if (!currentStatus) return "";
  return APPEAL_CURRENT_STATUS_LABELS[currentStatus] ?? currentStatus;
};
